import { Component } from '@angular/core';


@Component({
    selector: 'soft-menu-separator',
    imports: [],
    template: '',
    styleUrl: './menu-separator.component.css'
})
export class MenuSeparatorComponent {}
